import { render, staticRenderFns } from "./Olympiad.vue?vue&type=template&id=e6acf0b2&scoped=true&lang=pug&"
import script from "./Olympiad.vue?vue&type=script&lang=js&"
export * from "./Olympiad.vue?vue&type=script&lang=js&"
import style0 from "./Olympiad.vue?vue&type=style&index=0&id=e6acf0b2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6acf0b2",
  null
  
)

export default component.exports